export const sumFromArrayOfObjects = (arr, key) => arr?.reduce((a, b) => a + (((b.quantity || 1) * b[key]) || 0), 0);

export const requiredFormatter = (str, required) => required ? `${str} *` : str;

export const inputValue = e => e?.target?.value;

export const getRandomInt = max => Math.floor(Math.random() * max);

export const getRandomArbitrary = (min, max) => Math.random() * (max - min) + min;
